import type { Contract } from './types';

// Mint-Contract · logic lọc nhanh + nhãn hạn (chép từ script board: QF, expTxt).
export type QuickKey = 'all' | 'ap' | 'sg' | 'e30' | 'e60' | 'miss' | 'dup' | 'noc';

/** Khách có job 12 tháng nhưng chưa có hợp đồng (NOC của board). */
export const NO_CONTRACT = [
  { sn: 'VINAVARIETY', mst: '1801840323', jobs: 4, last: '19/Oct/2026', sale: 'DAVID' },
  { sn: 'PHUCUONGEXIM', mst: '0318•••507', jobs: 14, last: '18/Oct/2026', sale: 'TUANNT' },
  { sn: 'QUEKYCORP', mst: '1602051719', jobs: 22, last: '19/Oct/2026', sale: 'ANDG' },
] as const;

export function dupCounts(all: readonly Contract[]): Record<string, number> {
  const m: Record<string, number> = {};
  all.forEach((x) => { m[x.customer] = (m[x.customer] ?? 0) + 1; });
  return m;
}

export const QUICK: { key: QuickKey; label: string }[] = [
  { key: 'all', label: 'Tất cả' },
  { key: 'ap', label: 'Chờ duyệt' },
  { key: 'sg', label: 'Chưa ký' },
  { key: 'e30', label: 'Sắp hết 30 ngày' },
  { key: 'e60', label: 'Sắp hết 60 ngày' },
  { key: 'miss', label: 'Thiếu trường' },
  { key: 'dup', label: 'Trùng MST' },
  { key: 'noc', label: 'Có job chưa có HĐ' },
];

export function quickMatch(key: QuickKey, x: Contract, dup: Record<string, number>): boolean {
  switch (key) {
    case 'all': return true;
    case 'ap': return !x.approved;
    case 'sg': return !x.signed;
    case 'e30': return x.daysLeft >= 0 && x.daysLeft <= 30;
    case 'e60': return x.daysLeft >= 0 && x.daysLeft <= 60;
    case 'miss': return x.missing.length > 0;
    case 'dup': return (dup[x.customer] ?? 0) > 1;
    case 'noc': return false;
  }
}

export function quickCount(key: QuickKey, all: readonly Contract[]): number {
  if (key === 'noc') return NO_CONTRACT.length;
  const d = dupCounts(all);
  return all.filter((x) => quickMatch(key, x, d)).length;
}

export function searchContracts(rows: readonly Contract[], q: string): Contract[] {
  const u = q.trim().toUpperCase();
  return u ? rows.filter((x) => `${x.code} ${x.customer} ${x.mst}`.toUpperCase().includes(u)) : [...rows];
}

export function expiryText(x: Contract, dup: Record<string, number>): string {
  if (x.daysLeft < 0) return (dup[x.customer] ?? 0) > 1 ? 'Hết hạn · có HĐ mới' : x.signed ? 'Đã tự gia hạn' : 'Hết hạn';
  return x.daysLeft <= 60 ? `Còn ${x.daysLeft} ngày` : 'Còn hiệu lực';
}
export const expiryTone = (x: Contract): 'err' | 'warn' | 'none' => (x.daysLeft >= 0 && x.daysLeft <= 30 ? 'err' : x.daysLeft >= 0 && x.daysLeft <= 60 ? 'warn' : 'none');
export const creditText = (x: Contract) => (x.credit === 'Credit' ? `Credit · ${x.dueDays ? `${x.dueDays} ngày` : '— ngày'}` : `Non-Credit · ${x.dueDays || 7} ngày`);
